export default __webpack_public_path__ + "static/media/coin.9a754d14.png";